{
  "title": "Oyun lobisi",
  "subtitle": "Aggregator kataloğundaki tüm oyunlar burada.",
  "searchPlaceholder": "Oyun ara",
  "history": "Oyun geçmişi",
  "searchResults": "Arama",
  "bonusContinueTitle": "Bonusla devam edilsin mi?",
  "bonusContinueBody": "Ana bakiye 0. Bonus bakiyeniz var — yalnızca siz seçerseniz kullanılır.",
  "openExternal": "Oyunu aç",
  "openExternalHint": "Oyun uygulama içinde yüklenmezse aşağıdaki düğmeyle açın.",
  "backToCatalog": "Kataloğa dön",
  "notFound": "Oyun bulunamadı",
  "categories": "Kategoriler",
  "all": "Tümü",
  "slots": "Slotlar",
  "live": "Canlı casino",
  "crash": "Crash",
  "instant": "Anlık",
  "table": "Masa",
  "other": "Diğer",
  "popular": "Popüler",
  "new": "Yeni",
  "jackpot": "Jackpot",
  "tags": "Hızlı filtreler",
  "providers": "Sağlayıcılar",
  "emptyTitle": "Oyunlar henüz kullanılamıyor",
  "emptyBody": "Sağlayıcı kataloğu senkronize edilmedi. Gerçek veya demo oyun yalnızca doğrulanmış entegrasyondan sonra açılır.",
  "errorTitle": "Katalog yüklenemedi",
  "errorBody": "Oyunlar alınırken bir sorun oluştu. Kısa süre sonra tekrar deneyin.",
  "notPlayable": "Şu an kullanılamıyor",
  "demoUnavailable": "Demo henüz aktif değil",
  "realMoneyDisabled": "Gerçek parayla oyun kapalı",
  "provider": "Sağlayıcı",
  "results": "{{count}} oyun",
  "featured": "Öne çıkan",
  "lobbySection": "Katalog",
  "allProviders": "Tüm sağlayıcılar",
  "sort": "Sırala",
  "sortRecommended": "Önerilen",
  "sortName": "Ad",
  "sortProvider": "Sağlayıcı",
  "favorite": "Favori",
  "selectWallet": "Oynamadan önce bakiye seçin",
  "realBalance": "Gerçek bakiye",
  "bonusBalance": "Bonus bakiye",
  "fundingLocked": "Seçilen bakiye tüm oyun oturumu boyunca kilitli kalır. Gerçek ve bonus bakiyeler birleştirilmez.",
  "launchPlay": "Oyna",
  "bonusNotSlot": "Bonus yalnızca doğrulanmış slot oyunlarında kullanılabilir",
  "bonusPlayDisabled": "Bonusla oyun henüz aktif değil",
  "sessionFundingUnsupported": "Sağlayıcı bu fon kaynağını oturum için güvenle tutamıyor. Bu mod engellendi.",
  "loginToPlay": "Oynamak için giriş yapın",
  "sessionLaunched": "Oyun oturumu oluşturuldu",
  "loadMore": "Daha fazla göster",
  "loadingMore": "Yükleniyor…",
  "showingOf": "{{shown}} / {{total}} oyun",
  "launchDemo": "DEMO OYNA",
  "launchReal": "GERÇEK BAKİYEYLE OYNA",
  "launchBonus": "BONUS BAKİYEYLE OYNA",
  "demoLaunched": "Demo oturumu oluşturuldu",
  "recommended": "Önerilen",
  "fastGames": "Hızlı oyunlar",
  "bonusWager": "Bonus çevrim"
}
